export default __webpack_public_path__ + "static/media/family-logo.5c48c510.svg";